import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import NumberFormat from "react-number-format";
import dayjs from "dayjs";
import {
  Button,
  Table,
  Spinner,
  Modal,
  Form,
  Row,
  Col,
  ButtonGroup,
  Alert,
  Collapse,
} from "react-bootstrap";
import { HiSearchCircle } from "react-icons/hi";

import { ArrowRight, Check, CheckCircle } from "react-bootstrap-icons";
import { useUser, useFirestore, useFunctions } from "reactfire";
import { httpsCallable } from "firebase/functions";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  getDoc,
  addDoc,
  setDoc,
  doc,
  orderBy,
  limit,
  collectionGroup,
  onSnapshot,
} from "firebase/firestore";
import CryptoJS from "crypto-js";
import { Formik, useField, useFormikContext } from "formik";
import * as Yup from "yup";
import StockCardSummaryRecon from "../helpers/StockCardSummaryRecon";

var relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);

const SPECIAL_COLOUR_YELLOW = "#D0872E";
const defaultState = 1;

// const initState = {
//   washingAndDrying: defaultState,
//   paintCorrection: defaultState,
//   polishingAndWaxing: defaultState,
//   wheelAndTyreCleaning: defaultState,
//   windowCleaning: defaultState,
//   bugAndTarRemoval: defaultState,
//   paintDecontamination: defaultState,
//   vacuumingAndCleaning: defaultState,
//   upholsteryCleaning: defaultState,
//   dashboardAndConsoleCleaning: defaultState,
//   deodorisation: defaultState,
//   sanitisation: defaultState,
//   leatherConditioning: defaultState,
//   interiorGlassPolishing: defaultState,
//   compartmentCleaning: defaultState,
//   minorRepairs: defaultState,
// };

const initState = {};

const validationSchemaQC = Yup.object().shape({
  washingAndDrying: Yup.number().required("Required"),
  paintCorrection: Yup.number().required("Required"),
  polishingAndWaxing: Yup.number().required("Required"),
  wheelAndTyreCleaning: Yup.number().required("Required"),
  windowCleaning: Yup.number().required("Required"),
  bugAndTarRemoval: Yup.number().required("Required"),
  paintDecontamination: Yup.number().required("Required"),
  vacuumingAndCleaning: Yup.number().required("Required"),
  upholsteryCleaning: Yup.number().required("Required"),
  dashboardAndConsoleCleaning: Yup.number().required("Required"),
  deodorisation: Yup.number().required("Required"),
  sanitisation: Yup.number().required("Required"),
  leatherConditioning: Yup.number().required("Required"),
  interiorGlassPolishing: Yup.number().required("Required"),
  compartmentCleaning: Yup.number().required("Required"),
  minorRepairs: Yup.number().required("Required"),
});

const defaultOptions = [
  { label: "Pass", value: 1 },
  { label: "Fail", value: 0 },
  { label: "N/A", value: -1 },
];

const formFieldsExterior = [
  {
    name: "washingAndDrying",
    label: "Washing and Drying",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "paintCorrection",
    label: "Paint Correction (Touch up)",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
    specialColour: SPECIAL_COLOUR_YELLOW,
  },
  {
    name: "polishingAndWaxing",
    label: "Polishing and Waxing",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "wheelAndTyreCleaning",
    label: "Wheel and Tyre Cleaning",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "windowCleaning",
    label: "Window Cleaning",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "bugAndTarRemoval",
    label: "Bug and Tar Removal",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "paintDecontamination",
    label: "Paint Decontamination",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "minorRepairs",
    label: "Minor Repairs (dent)",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
    specialColour: SPECIAL_COLOUR_YELLOW,
  },
];

const formFieldsInterior = [
  {
    name: "vacuumingAndCleaning",
    label: "Vacuuming and Cleaning",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "upholsteryCleaning",
    label: "Upholstery Cleaning",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
    specialColour: SPECIAL_COLOUR_YELLOW,
  },
  {
    name: "dashboardAndConsoleCleaning",
    label: "Dashboard and Console Cleaning",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "deodorisation",
    label: "Deodorisation",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "sanitisation",
    label: "Sanitisation",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "leatherConditioning",
    label: "Leather Conditioning",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
    specialColour: SPECIAL_COLOUR_YELLOW,
  },
  {
    name: "interiorGlassPolishing",
    label: "Interior Glass Polishing",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "compartmentCleaning",
    label: "Compartment Cleaning",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
];

const fieldsRequiringNextYardChangeTouchup = [
  "minorRepairs",
  "paintCorrection",
  "upholsteryCleaning",
  "leatherConditioning",
];

const ReconVehicleDetailModalQC = ({
  data,
  show,
  handleClose,
  createNew = false,
  stateFilter,
  buyingFilterUserRoles,
}) => {
  const [loading, setLoading] = useState(false);
  const [localData, setLocalData] = useState(data);

  const [saving, setSaving] = useState(false);
  const [refreshToggle, setRefreshToggle] = useState(false);

  const [numberOfKeys, setNumberOfKeys] = useState(null);
  const [serviceHistory, setServiceHistory] = useState(null);

  const [existingQCForm, setExistingQCForm] = useState([]);

  const [checklistOutcome, setChecklistOutcome] = useState(null);

  const [nextYardLocation, setNextYardLocation] = useState("VICPhoto");

  //   Hooks
  const firestore = useFirestore();
  const user = useUser();
  const functions = useFunctions();

  const handleErrors = (error) => {
    console.log(error);
  };

  const handleSaveQCChecklist = async (values, setSubmitting) => {
    // if > 1 form exists, show confirmation modal
    if (existingQCForm.length > 0) {
      const confirm = window.confirm(
        "This vehicle already has an arrival form. Do you want to overwrite it?"
      );
      if (!confirm) {
        toast.error("Form not saved");
        return;
      }
    }
    setSaving(true);
    setSubmitting(true);
    console.log(values);

    console.log(data);
    console.log(user);

    // Checklist outcome logic: Loop through the form fields and check if any of them are "Fail" (0) skip -1
    const checklistOutcomeArray = Object.keys(values).map((key) => {
      console.log(key, values[key]);
      if (values[key] === 0) {
        return 0;
      }
      if (values[key] === -1) {
        return 1;
      }
      return 1;
    });

    console.log("checklistOutcome", checklistOutcomeArray);

    const checklistOutcome = checklistOutcomeArray.includes(0) ? 0 : 1;

    const qcChecklistPayload = {
      ...values,
      createdBy: user?.data?.displayName,
      createdByEmail: user?.data?.email,
      createdByPhone: user?.data?.phoneNumber,
      createdById: user?.data?.uid,
      createdAt: dayjs().unix(),
      vin: data?.veh?.VEHVIN,
      stockNumber: data?.veh?.VEHStockNumber,
      branchId: data?.veh?.BranchId,
      branchName: data?.veh?.Branch,
      make: data?.veh?.VEHMake,
      model: data?.veh?.VEHmodel,
      year: data?.veh?.VEHModelYear,
      yard: data?.veh?.VEHYard,
      odometer: data?.veh?.VEHOdo,
      checklistOutcome: checklistOutcome ? 1 : 0,
      checklistOutcomeText: checklistOutcome ? "Passed" : "Failed",
    };

    console.log(qcChecklistPayload);
    // Create an md5 hash of VEHStockNumber and VEHVIN
    const stockVin = `${data?.veh.VEHStockNumber}${data?.veh.VEHVIN}`;
    const hash = CryptoJS.MD5(stockVin).toString();
    console.log(stockVin, hash);

    const qcChecklistRef = await addDoc(
      collection(firestore, "reconditioning-process", hash, "recon-form-qa"),
      qcChecklistPayload
    )
      .then((r) => {
        toast.success("Saved form");
        setRefreshToggle((prev) => !prev);
      })
      .catch((e) => {
        toast.error("Error saving form");
        console.log(e);
      });

    // @TODO - UNCOMMENT THIS AFTER CHANGING TO RECON BRANCH
    await pushToNextYardLocation();
    setSaving(false);
    setSubmitting(false);
  };

  const pushToNextYardLocation = async () => {
    const yardLocation = nextYardLocation;
    const yardLocationComments = `Changed by ${user.data.displayName} from ${data?.veh?.VEHYard} to ${yardLocation}`;

    const payload = {
      selectedVehicle: data?.veh,
      comments: yardLocationComments,
      createdAt: dayjs().format("YYYY-MM-DD"),
      createdBy: user.data.displayName,
      VEHStockNumber: data?.veh?.VEHStockNumber,
      VIN: data?.veh?.VEHVIN,
      originalBranch: data?.veh?.Branch,
      yardLocation: yardLocation,
      EclipseDBName: data?.veh?.db,
      EclipseBranchID: data?.veh?.BranchId,

      actioned: false,
      actionStatus: null,
      actionedTimestamp: null,
      action: "GENERAL_YARD_LOG_UPDATE",
    };

    // Callable function
    const yardChangeLogRequestD1VIC = httpsCallable(
      functions,
      "yardChangeLogRequestD1VIC"
    );

    await yardChangeLogRequestD1VIC({
      yardChangeData: payload,
      selectedVehicle: data?.veh,
    })
      .then((r) => {
        console.log(r);
        if (r.data.status === "success") {
          toast.success("Yard location update queued");
          toast.success(
            "Yard log should update to Inspection in Eclipse in 5 minutes"
          );
        } else {
          toast.error("Yard location update failed");
        }
      })
      .catch((e) => {
        toast.error(e.message);
      });
  };

  // On mount load any existing arrival forms
  useEffect(() => {
    const stockVin = `${data?.veh.VEHStockNumber}${data?.veh.VEHVIN}`;
    const hash = CryptoJS.MD5(stockVin).toString();
    console.log(stockVin, hash);
    const arrivalChecklistRef = collection(
      firestore,
      "reconditioning-process",
      hash,
      "recon-form-qa"
    );
    const q = query(arrivalChecklistRef, orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const arrivalForms = [];
      querySnapshot.forEach((doc) => {
        arrivalForms.push({ id: doc.id, ...doc.data() });
      });
      console.log(arrivalForms);
      setExistingQCForm(arrivalForms);
    });
    return () => {
      unsubscribe();
    };
  }, [JSON.stringify(data), refreshToggle]);

  useEffect(() => {
    // Refresh the data when the modal state changes or refreshToggle changes
    setLocalData(data);
    setExistingQCForm([]);
  }, [show, refreshToggle]);

  return (
    <Modal show={show} size="xl" onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>
          <h5>
            {data?.veh?.VEHStockNumber} -{" "}
            {`${data?.veh?.VEHModelYear} ${data?.veh?.VEHMake} ${data?.veh?.VEHmodel}`}
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <h4>QC checklist</h4>
            {existingQCForm.length > 0 && (
              <div>
                <h5>Existing saved forms</h5>
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>Created At</th>
                      <th>Created By</th>
                      <th>Outcome</th>
                    </tr>
                  </thead>
                  <tbody>
                    {existingQCForm.map((form) => {
                      return (
                        <tr key={form.id}>
                          <td>
                            {dayjs
                              .unix(form.createdAt)
                              .format("DD/MM/YYYY HH:mm")}
                          </td>
                          <td>{form.createdBy}</td>
                          <td>
                            {form.checklistOutcome === 1 ? (
                              <CheckCircle
                                style={{ color: "green", fontSize: 20 }}
                              />
                            ) : form.checklistOutcome === 0 ? (
                              <div style={{ color: "red" }}>Failed</div>
                            ) : null}
                          </td>
                          {/* <td>
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => {
                                // setLocalData(form);
                                // setShowArrivalForm(true);
                              }}
                            >
                              View
                            </Button>
                          </td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            )}
            <Formik
              initialValues={initState}
              enableReinitialize={true}
              validateOnSubmit={true}
              validateOnChange={true}
              validationSchema={validationSchemaQC}
              onSubmit={(values, { setSubmitting }) =>
                handleSaveQCChecklist(values, setSubmitting)
              }
            >
              {({
                values,
                errors,
                isSubmitting,
                handleSubmit,
                handleChange,
                setFieldValue,
              }) => {
                const handleChangeNextYardLocation = (nV, fieldName) => {
                  // Parse through all form fields and their current values
                  console.log("handleChangeNextYardLocation called");
                  console.log("Current values:", values);
                  console.log("Field name:", fieldName);

                  // Check if any of the fields that require next yard location change are set to 1 (Pass)

                  const shouldChangeNextYardLocationTouchup =
                    fieldsRequiringNextYardChangeTouchup.some((field) => {
                      if (fieldName !== field) {
                        return values[field] === 0;
                      } else {
                        return nV === 0;
                      }
                    });
                  console.log(
                    "shouldChangeNextYardLocationTouchup:",
                    shouldChangeNextYardLocationTouchup
                  );

                  // If any of the fields are set to 1, change next yard location to "VICTouchup"
                  if (nV === 1 && !shouldChangeNextYardLocationTouchup) {
                    setNextYardLocation("VICPhoto");
                  } else if (shouldChangeNextYardLocationTouchup || nV === 0) {
                    setNextYardLocation("TOUCHUP");
                  }
                };

                return (
                  <form onSubmit={handleSubmit}>
                    <h5
                      style={{ fontWeight: 600, textDecoration: "underline" }}
                    >
                      Exterior
                    </h5>
                    {formFieldsExterior.map((field, index) => {
                      if (field.type === "radio") {
                        return (
                          <Form.Group
                            key={index}
                            controlId={field.name}
                            style={{
                              marginTop: 10,

                              // alternate background color
                              backgroundColor:
                                index % 2 === 0 ? "#f8f9fa" : "#fff",
                              padding: 10,
                            }}
                          >
                            <Form.Label
                              style={{ color: field.specialColour || "black" }}
                            >
                              {field.label}
                            </Form.Label>
                            <ButtonGroup
                              style={{ flexWrap: "wrap", float: "right" }}
                            >
                              {field.options.map((option, index) => {
                                return (
                                  <Button
                                    key={index}
                                    variant={
                                      values[field.name] === option.value
                                        ? "primary"
                                        : "outline-primary"
                                    }
                                    onClick={() => {
                                      setFieldValue(field.name, option.value);
                                      console.log(
                                        `Field ${field.name} changed to ${option.value}`
                                      );
                                      // Handle next yard location change based on field name and value
                                      if (
                                        fieldsRequiringNextYardChangeTouchup.includes(
                                          field.name
                                        )
                                      ) {
                                        handleChangeNextYardLocation(
                                          option.value,
                                          field.name
                                        );
                                      }
                                    }}
                                  >
                                    {option.label}
                                  </Button>
                                );
                              })}
                            </ButtonGroup>

                            {errors[field.name] ? (
                              <div
                                style={{
                                  color: "red",
                                  fontSize: 12,
                                  marginTop: 5,
                                  float: "right",
                                  marginRight: 10,
                                }}
                              >
                                {errors[field.name]}
                              </div>
                            ) : null}
                          </Form.Group>
                        );
                      }
                    })}

                    <h5
                      style={{ fontWeight: 600, textDecoration: "underline" }}
                    >
                      Interior
                    </h5>
                    {formFieldsInterior.map((field, index) => {
                      if (field.type === "radio") {
                        return (
                          <Form.Group
                            key={index}
                            controlId={field.name}
                            style={{
                              marginTop: 10,

                              // alternate background color
                              backgroundColor:
                                index % 2 === 0 ? "#f8f9fa" : "#fff",
                              padding: 10,
                            }}
                          >
                            <Form.Label
                              style={{ color: field.specialColour || "black" }}
                            >
                              {field.label}
                            </Form.Label>
                            <ButtonGroup
                              style={{ flexWrap: "wrap", float: "right" }}
                            >
                              {field.options.map((option, index) => {
                                return (
                                  <Button
                                    key={index}
                                    variant={
                                      values[field.name] === option.value
                                        ? "primary"
                                        : "outline-primary"
                                    }
                                    onClick={() => {
                                      setFieldValue(field.name, option.value);
                                      console.log(
                                        `Field ${field.name} changed to ${option.value}`
                                      );
                                      // Handle next yard location change based on field name and value
                                      if (
                                        fieldsRequiringNextYardChangeTouchup.includes(
                                          field.name
                                        )
                                      ) {
                                        handleChangeNextYardLocation(
                                          option.value,
                                          field.name
                                        );
                                      }
                                    }}
                                  >
                                    {option.label}
                                  </Button>
                                );
                              })}
                            </ButtonGroup>

                            {errors[field.name] ? (
                              <div
                                style={{
                                  color: "red",
                                  fontSize: 12,
                                  marginTop: 5,
                                  float: "right",
                                  marginRight: 10,
                                }}
                              >
                                {errors[field.name]}
                              </div>
                            ) : null}
                          </Form.Group>
                        );
                      }
                    })}

                    <Row style={{ marginTop: 10 }}>
                      <Col>
                        <Button
                          variant="primary"
                          type="submit"
                          id="frm-submit-btn"
                          disabled={isSubmitting}
                          size="sm"
                        >
                          Save and send to {nextYardLocation}{" "}
                        </Button>
                      </Col>
                    </Row>
                    <Collapse in={isSubmitting}>
                      <Row style={{ marginTop: 10 }}>
                        <Col>
                          <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                          </Spinner>
                        </Col>
                      </Row>
                    </Collapse>
                  </form>
                );
              }}
            </Formik>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <StockCardSummaryRecon
          veh={data?.veh}
          yardLogs={data?.veh?.yardLogs || []}
        />
        {/* {JSON.stringify(data, null, 2)} */}
        <Button onClick={handleClose} variant="secondary">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReconVehicleDetailModalQC;
